// eslint-disable-next-line no-undef
iFrameResize({}, '#event-registration-iframe');
